import { Theme, css } from '@emotion/react';

export const headerNavigation = ({ breakpoints }: Theme) => css`
  display: none;
  ${breakpoints.up('md')} {
    display: block;
  }
`;

export const headerTitle = ({ spacing }: Theme) => css`
  padding-top: ${spacing(3)}px;
`;
